import { useCallback, useEffect, useState } from 'react';
import { StickTo } from '../Table.decl';
export var useHorizontalScrollAtEnd = function useHorizontalScrollAtEnd(scrollableContainer, stickTo, contentLoading) {
  var isHorizontalScrollAtEnd = useCallback(function () {
    if (stickTo && scrollableContainer) {
      if (stickTo === StickTo.Left) {
        return scrollableContainer.scrollLeft === 0;
      } else {
        return scrollableContainer.scrollLeft + scrollableContainer.offsetWidth >= scrollableContainer.scrollWidth;
      }
    }

    return false;
  }, [stickTo, scrollableContainer]);

  var _useState = useState(),
      scrollAtEnd = _useState[0],
      setScrollAtEnd = _useState[1];

  useEffect(function () {
    setScrollAtEnd(isHorizontalScrollAtEnd());

    var handleScrollPositionChange = function handleScrollPositionChange() {
      setScrollAtEnd(isHorizontalScrollAtEnd());
    };

    window.addEventListener('resize', handleScrollPositionChange);
    scrollableContainer == null ? void 0 : scrollableContainer.addEventListener('scroll', handleScrollPositionChange);
    return function () {
      window.removeEventListener('resize', handleScrollPositionChange);
      scrollableContainer == null ? void 0 : scrollableContainer.removeEventListener('scroll', handleScrollPositionChange);
    };
  }, [stickTo, scrollableContainer, contentLoading, isHorizontalScrollAtEnd]);
  return scrollAtEnd;
};